<template>
  <div>
    <p :class="['profit_item', profitClass]">
      {{ type }} Profit <span>{{ amountFormatted }}</span>
    </p>
    <p v-if="hint" class="profit_hint">{{ hint }}</p>
  </div>
</template>

<script>
export default {
  name: "ProfitItem",
  props: {
    type: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      default: 0
    },
    hint: {
      type: String
    }
  },
  computed: {
    amountFormatted() {
      if(this.amount) {
        return this.$utils.formatCurrency(this.amount);
      } else {
        return '--';
      }
    },
    profitClass() {
      if(this.amount > 0) {
        return 'is-positive';
      }

      if(this.amount < 0) {
        return 'is-negative';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.profit_item {
  font-weight: bold;

  span {
    float: right;
  }

  &.is-positive {
    span {
      color: $success;
    }
  }

  &.is-negative {
    span {
      color: $danger;
    }
  }
}

.profit_hint {
  margin-top: 6px;
  font-size: 13px;
  color: $text-muted;
}
</style>
